import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">
            首页
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-xs" />
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}